import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, ViewChild } from "@angular/core";
import { AngularResizeElementEvent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/resizable/angular-resize-element-event.interface";
import { AngularResizeElementDirection } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/resizable/angular-resize-element.enum";
import { ContextMenuEnum } from "../../../model/contextMenuenum";
import { ItemOrderService } from "../itemorder.service";
import { SimpleMenuComponent } from "./contextment";
import { CommonService } from "projects/sepidz-web-framework/src/lib/services/common.service";
import { OrderSizeEnum } from "../../../model/orderSize.enum";
import { OrderSettingModel, OrderSizeModel } from "../../../model/ordersetting.model";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { Validators } from "@angular/forms";
import { Permission } from "projects/sepidz-web-framework/src/lib/models";
import { Subject } from "rxjs";
import { CategoryPopupState } from "src/app/frontoffice/catalog/model/item.model";
import { OrderItem } from "../../../model/orderItemcategory.model";
@Component({
  selector: "order-item",
  templateUrl: "./item.component.html",
  styleUrls: ["./item.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemComponent implements OnDestroy {
  [x: string]: any;
  public changeView: boolean = false;
  public changeCatView: boolean = false;
  menu = SimpleMenuComponent;
  popUpState = CategoryPopupState;
  public contextmenuEnum: typeof ContextMenuEnum = ContextMenuEnum;
  highlightStar: boolean = false;
  @ViewChild("container", { read: ElementRef })
  public readonly containerElement;
  ngUnsubscribe = new Subject<any>();
  constructor(public cd: ChangeDetectorRef, public itemService: ItemOrderService, public common: CommonService, __id: FormContainerModel) {
    this.itemService.order.cd_Footer = this.cd;
    this.itemService.order.__id = __id.metadata.id;
  }

  public readonly AngularResizeElementDirection = AngularResizeElementDirection;
  public data: any = {};

  public Resize(evt: AngularResizeElementEvent): void {
    this.data.width = evt.currentWidthValue;
    this.data.height = evt.currentHeightValue;
    this.data.top = evt.currentTopValue;
    this.data.left = evt.currentLeftValue;
  }
  resizeEnd(evt: AngularResizeElementEvent) {
    const orderSize = new OrderSizeModel();
    orderSize.width = evt.currentWidthValue;
    orderSize.height = evt.currentHeightValue;
    orderSize.top = evt.currentTopValue;
    orderSize.left = evt.currentLeftValue;
    orderSize.key = OrderSizeEnum.Item;
    orderSize.saleBranchId = this?.itemService?.order?.saleMethodBranch?.Id;

    if (!this.common.LocalSetting.OrderSetting) this.common.LocalSetting.OrderSetting = new OrderSettingModel();
    if (!this.common?.LocalSetting?.OrderSetting?.OrderSize) this.common.LocalSetting.OrderSetting.OrderSize = [];

    const index = this.common.LocalSetting.OrderSetting.OrderSize.findIndex(
      (f) => f.key === OrderSizeEnum.Item && f.saleBranchId === this.itemService.order.saleMethodBranch.Id
    );

    if (index < 0) this.common.LocalSetting.OrderSetting.OrderSize.push(orderSize);
    else this.common.LocalSetting.OrderSetting.OrderSize[index] = orderSize;

    this.common.updateSettings();
  }
  getSetting() {
    this.itemService.order.OrderSetting = this.common.LocalSetting?.OrderSetting;
    this.changeView = this.itemService.order.OrderSetting.changeView;
    this.changeCatView = this.itemService.order.OrderSetting.changeCatView;
    const evt = this.itemService?.order?.OrderSetting?.OrderSize?.find(
      (f) => f.key === OrderSizeEnum.Item && f.saleBranchId === this.itemService.order.saleMethodBranch.Id
    );
    if (evt) {
      this.data.width = evt.width;
      this.data.height = evt.height;
      this.data.top = evt.top;
      this.data.left = evt.left;
      this.itemService.order.saleMethodBranch.Id = evt.saleBranchId;
    }
    this.cd.markForCheck();
  }

  changeCategoryView() {
    this.changeCatView = !this.changeCatView;
    this.common.LocalSetting.OrderSetting.changeCatView = this.changeCatView;
    this.common?.updateSettings(this.common?.LocalSetting?.OrderSetting);
  }

  changeItemView() {
    this.changeView = !this.changeView;
    this.common.LocalSetting.OrderSetting.changeView = this.changeView;
    this.common?.updateSettings(this.common?.LocalSetting?.OrderSetting);
  }

  ngOnInit() {
    this.itemService.order.setValue(`Quantity${this.itemService.order.__id}`, undefined, false, Validators.maxLength(20));
    this.itemService.order.setValue(`ItemTitle${this.itemService.order.__id}`, undefined, false, Validators.maxLength(500));
    this.itemService.order.setValue(`Code${this.itemService.order.__id}`, undefined, false, Validators.maxLength(20));
    this.itemService.order.focusInput();
    this.getSetting();
  }

  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
  }

  depositShowHide() {
    const hasAccess = this.itemService.order.accountService.userHasPermission(`RestaurantSale:Deposit`, Permission.createPermission);
    if (hasAccess) this.itemService.order.isShowDeposit = !this.itemService.order.isShowDeposit;
    else this.itemService.sts.showToast("danger", "", this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Desktop.AccessToThisArea"));
  }

  ClearItemNameInput() {
    this.itemService.order.setValue(`ItemTitle${this.itemService.order.__id}`, "");
  }

  async checkfavorite(item: OrderItem) {
    if (item.favoriteIndex > -1) {
      let favItem = this.itemService.order.favoriteItems.find((it) => it.ItemId == item.Id);
      if (this.itemService.order.accountService.userHasPermission("RestaurantSale:FavoriteItem", "Delete")) {
        await this.itemService.order.deleteFav(favItem);
        item.favoriteIndex = -1;
        this.updateArray();
      } else {
        this.itemService.sts.showToast(
          "control",
          this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Desktop.NoAccess"),
          this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Desktop.DoNotAccessToChangePreferences")
        );
      }
    } else {
      if (this.itemService.order.accountService.userHasPermission("RestaurantSale:FavoriteItem", "Post")) {
        await this.itemService.order.setFavorite(item);
        this.updateArray();
      } else {
        this.itemService.sts.showToast(
          "control",
          this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Desktop.NoAccess"),
          this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Desktop.DoNotAccessToChangePreferences")
        );
      }
    }
    this.cd.detectChanges();
  }

  updateArray() {
    if (this.itemService.order.selectedItemCategory.Id == 0) {
      const bundles = this.itemService.order.getBundles();
      for (let bundle of bundles) {
        this.itemService.order.sortingArrayByFav(bundle.ItemChild);
      }
      let tempArr = this.itemService.order.sortingArrayByFav(this.itemService.order.selectedItemCategory.Items);
      this.itemService.order.selectedItemCategory.Items = null;
      this.itemService.order.selectedItemCategory.Items = [...tempArr];
      if (this.itemService.order.itemHasParent) {
        tempArr = this.itemService.order.sortingArrayByFav(this.itemService.order.itemHasParent);
        this.itemService.order.itemHasParent = null;
        this.itemService.order.itemHasParent = [...tempArr];
      }
    }
    this.cd.detectChanges();
  }

  backOfBundle() {
    this.itemService.order.itemHasParent = null;
    if (this.itemService.order.selectedItemCategory.Id == 0) {
      let itemCategoryAll = this.itemService.order.itemCategoryList.find((it) => it.Id == 0);
      this.itemService.changeItemCategory(itemCategoryAll);
    }
    this.updateArray();
  }
}
